<template>
    <div class="slider-video player">
        <div class="slider-video-box">
            <video id="stream-player" ref="video" loop muted playsinline height="100%">
                <source :src="source" :type="typeVideo" >
            </video>
            <div class="slider-video-label" :style="`background: linear-gradient(90deg, ${colorSide} 0%,${colorMiddle} 35%, ${colorMiddle} 65%, ${colorSide} 100%); width: ${vWidth}px`" @click="gotoUrl()"></div>
        </div>
    </div>
</template>
<script>
import homeUtils from '@/Utilities/homeUtils';
export default {
    props:{
        source:{
            type: String,
            default: null
        },
        url:{
            type: String,
            default: null
        },
        color:{
            type: String,
            default: null
        },
        vWidth:{
            type: Number,
            default: 365
        }
    },
    data(){
        return {
            player: null
        }
    },
    mounted() {
        setTimeout(() => {this.play(false);}, 300);
    },
    computed: {
        typeVideo(){
            let ext = this.source && (/[.]/.exec(this.source)) ? /[^.]+$/.exec(this.source) : 'mp4';
            return `video/${ext}`;
        },
        colorSide(){
            if(!this.color){
                return 'rgba(255,255,255,1)';
            }
            let rgb = this.convertToRGB(this.color);
            return `rgba(${rgb[0]},${rgb[1]},${rgb[2]},1)`;
        },
        colorMiddle(){
            if(!this.color){
                return 'rgba(255,255,255,0)';
            }
            let rgb = this.convertToRGB(this.color);
            return `rgba(${rgb[0]},${rgb[1]},${rgb[2]},0)`;
        }
    },
    methods: {
        convertToRGB(clr){
            let color   = clr.replace('#','');
            let aRgbHex = color.match(/.{1,2}/g);
            if(color.length != 6){
                aRgbHex[0] = aRgbHex[0] + '' + aRgbHex[0];
                aRgbHex[1] = aRgbHex[1] + '' + aRgbHex[1];
                aRgbHex[2] = aRgbHex[2] + '' + aRgbHex[2];
            }

            var aRgb = [
                parseInt(aRgbHex[0], 16),
                parseInt(aRgbHex[1], 16),
                parseInt(aRgbHex[2], 16)
            ];
            return aRgb;
        },
        gotoUrl(){
            homeUtils.gotoUrl(this.url,null);
        },
        play(retry){
            if(!this.player){
                this.player = this.$refs.video;
            }
            if(this.player){
               this.player.load();
                let promise = this.player.play();
                if (promise !== undefined && !retry) {
                    promise.then( _ => {}).catch(error => {
                        this.player.muted = true;
                        this.play(true);
                    });
                } 
            }
        }
    }
}
</script>